var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 502,
    viewBox: "0 0 747 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.231 97.9503C210.301 50.6145 149.446 -28.7798 183.494 -74.2532C221.139 -124.53 292.069 -154.472 367.112 -152.973C445.041 -151.416 525.422 -113.373 592.216 -66.0877C657.5 -19.8714 709.839 41.6467 735.959 108.146C760.466 170.538 735.692 228.298 731.899 289.536C727.898 354.126 769.289 442.864 713.064 477.791C654.366 514.255 555.913 442.808 478.582 446.899C410.978 450.476 367.613 513.601 297.861 499.756C226.729 485.638 171.016 426.806 120.181 375.762C67.903 323.268 -10.8119 262.008 1.8347 202.509C15.7578 137.005 142.872 153.344 179.231 97.9503Z",
    fill: "#28CC9E",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstVector);
export default __webpack_public_path__ + "static/media/FirstVector.4c855e99e5907098d1b3dd113c813306.svg";
export { ForwardRef as ReactComponent };